require('./google-login-btn.less');

var bg = "url('assets/images/btn_google_signin_dark_normal_web@2x.png')";

angular.module('bbl.authorization')
  .directive('googleLoginBtn', ['ENV', 'Auth', '$location', GoogleLoginBtnDirective]);

var tmpl = '' +
'<button class="g-login-btn" ng-class="{ready: ready, wait: wait}" ng-click="login($event)" style="background-image: '+bg+'">{{"Sign in with Google"|translate}}</button>' +
'<script src="https://apis.google.com/js/client:platform.js?onload=gapiReady" async defer></script>';

function GoogleLoginBtnDirective(env, Auth, $location) {
  return {
    restrict: 'EA',
    template: tmpl,
    scope: {
      'onError': '&',
    },
    controller: ['$scope', function($scope) {
      window.gapiReady = function() {
        gapi.load('auth2', function() {
          $scope.auth2 = gapi.auth2.init({
            client_id: env.googleClientId,
          });

          $scope.ready = true;
        });
      };

      $scope.login = function(ev) {
        $scope.wait = true;
        ev.preventDefault();

        $scope.auth2.grantOfflineAccess().then(function(authResult) {
          var code = authResult.code;

          Auth.loginWith({provider: 'google', code: code}).then(function() {
            $scope.wait = false;
            $location.path('/#/dashboard');
          }, function(response) {
            if(response.status == 401 && !response.data.success) {
              $scope.onError({$event: 'Couldn\'t log in via Google at this time. Please try again later!'});
            }
          });
        });
      };
    }],
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/google-login-btn.js
 ** module id = 309
 ** module chunks = 0
 **/